<form [formGroup]="p2p1Form" *ngIf="p2p1Form" (ngSubmit)="onSubmit()" class="myform">

    <div class="p-5">
        <div class="flex justify-center items-baseline flex-wrap">
            <div class="flex m-2">
                <mat-form-field>
                    <mat-label>Gamma (ɣ) &nbsp; value</mat-label>
                    <input matInput formControlName="gVal" autocomplete="off">
                    <mat-error *ngIf="p2p1Form.invalid && p2p1Form.touched">
                      <span class="myerror">1.0 &lt; ɣ &le; 1.67</span>
                    </mat-error>
                  </mat-form-field>

            </div>

            <div class="flex m-2">
                <mat-form-field>
                    <mat-label>
                      <!-- <p2p1></p2p1> -->
                      p2/p1
                    </mat-label>
                    <input matInput formControlName="pVal" autocomplete="off">
                  </mat-form-field>

            </div>
        </div>
        <div class="sbmtArea flex justify-center items-baseline flex-wrap">
            <button mat-raised-button type="submit" [disabled]="p2p1Form.invalid">Calculate</button>
          </div>
    </div>
</form>